export const lookupConfig = [
    {
        tableName: 'countries',
        tableSimpleName: 'Države',
        url: '/countries',
        frontEndPath: 'drzave',
        columns: [
            {
                name: 'name',
                simpleName: 'Naziv države',
                type: 'text'
            },
            {
                name: 'officialName',
                simpleName: 'Oficijelni naziv',
                type: 'text'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }

        ]
    },
    {
        tableName: 'cantons',
        tableSimpleName: 'Kantoni',
        url: '/cantons',
        frontEndPath: 'kantoni',
        columns: [
            {
                name: 'name',
                simpleName: 'Naziv kantona',
                type: 'text'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ]
    },
    {
        tableName: 'document-statuses',
        tableSimpleName: 'Status dokumenta',
        url: '/document-statuses',
        frontEndPath: 'status-dokumenta',
        columns: [
            {
                name: 'name',
                simpleName: 'Status',
                type: 'text'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ]
    },
    {
        tableName: 'contact-types',
        tableSimpleName: 'Tip kontakta',
        url: '/contact-types',
        frontEndPath: 'tip-kontakta',
        columns: [
            {
                name: 'name',
                simpleName: 'Tip kontakta',
                type: 'text'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ]
    },
    {
        tableName: 'institution-types',
        tableSimpleName: 'Tip institucije',
        url: '/institution-types',
        frontEndPath: 'tip-institucije',
        columns: [
            {
                name: 'name',
                simpleName: 'Tip institucije',
                type: 'text'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ]
    },
    {
        tableName: 'education-levels',
        tableSimpleName: 'Nivo obrazovanja',
        url: '/education-levels',
        frontEndPath: 'nivo-obrazovanja',
        columns: [
            {
                name: 'name',
                simpleName: 'Nivo obrazovanja',
                type: 'text'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ]
    },
    {
        tableName: 'disability-types',
        tableSimpleName: 'Status studenta sa invaliditetom',
        url: '/disability-types',
        frontEndPath: 'status-studenta-sa-invaliditetom',
        columns: [
            {
                name: 'name',
                simpleName: 'Status studenta sa invaliditetom',
                type: 'text'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ]
    },
    {
        tableName: 'social-status-types',
        tableSimpleName: 'Socijalni status',
        url: '/social-status-types',
        frontEndPath: 'socijalni-status',
        columns: [
            {
                name: 'name',
                simpleName: 'Socijalni status',
                type: 'text'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ]
    },
    {
        tableName: 'nationalities',
        tableSimpleName: 'Nacionalnost',
        url: '/nationalities',
        frontEndPath: 'nacionalnost',
        columns: [
            {
                name: 'name',
                simpleName: 'Nacionalnost',
                type: 'text'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ]
    },
    {
        tableName: 'facultychangecausetype',
        tableSimpleName: 'Razlog promjene fakulteta',
        url: '/faculty-change-cause-types',
        frontEndPath: 'razlog-promjene-fakulteta',
        columns: [
            {
                name: 'name',
                simpleName: 'Razlog promjene fakulteta',
                type: 'text'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ]
    },
    {
        tableName: 'activitystatustype',
        tableSimpleName: 'Status u aktivnosti',
        url: '/activity-status-types',
        frontEndPath: 'status-u-aktivnosti',
        columns: [
            {
                name: 'name',
                simpleName: 'Status u aktivnosti',
                type: 'text'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ]
    },
    {
        tableName: 'languages',
        tableSimpleName: 'Jezik',
        url: '/languages',
        frontEndPath: 'jezik',
        columns: [
            {
                name: 'name',
                simpleName: 'Jezik',
                type: 'text'
            },
            {
                name: 'twoLetterCode',
                simpleName: 'Šifra',
                type: 'text'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ]
    },
    {
        tableName: 'studentstatus',
        tableSimpleName: 'Status studenta',
        url: '/student-statuses',
        frontEndPath: 'status-studenta',
        columns: [
            {
                name: 'name',
                simpleName: 'Status studenta',
                type: 'text'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ]
    },
    {
        tableName: 'financemethod',
        tableSimpleName: 'Metode finansiranja',
        url: '/finance-methods',
        frontEndPath: 'metode-finansiranja',
        columns: [
            {
                name: 'name',
                simpleName: 'Metode finansiranja',
                type: 'text'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ]
    },
    {
        tableName: 'financesource',
        tableSimpleName: 'Izvor finansiranja',
        url: '/finance-sources',
        frontEndPath: 'izvor-finansiranja',
        columns: [
            {
                name: 'name',
                simpleName: 'Izvor finansiranja',
                type: 'text'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ]
    },
    {
        tableName: 'semesternames',
        tableSimpleName: 'Naziv semestra',
        url: '/semester-names',
        frontEndPath: 'naziv-semestra',
        columns: [
            {
                name: 'name',
                simpleName: 'Naziv semestra',
                type: 'text'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ]
    },
    {
        tableName: 'courseroletypes',
        tableSimpleName: 'Uloge na predmetu',
        url: '/course-role-types',
        frontEndPath: 'uloge-na-kursu',
        columns: [
            {
                name: 'name',
                simpleName: 'Uloge na predmetu',
                type: 'text'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ]
    },
    // {
    //     tableName: 'attributes',
    //     tableSimpleName: 'Atributi (document)',
    //     url: '/attributes',
    //     frontEndPath: 'atributi',
    //     columns: [
    //         {
    //             name: 'name',
    //             simpleName: 'Naziv',
    //             type: 'text'
    //         },
    //         {
    //             name: 'displayName',
    //             simpleName: 'Naziv',
    //             type: 'text',
    //         }
    //     ]
    // },
    {
        tableName: 'documenttypes',
        tableSimpleName: 'Vrste dokumenta',
        url: '/document-types',
        frontEndPath: 'vrsta-dokumenta',
        columns: [
            {
                name: 'name',
                simpleName: 'Naziv',
                type: 'text'
            },
            {
                name: 'graduation',
                simpleName: 'Diplomski dokument?',
                type: 'bool',
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ],
    },
    {
        tableName: 'study_cycle',
        tableSimpleName: 'Ciklus studiranja',
        url: '/study-cycles',
        frontEndPath: 'ciklus-studiranja',
        columns: [
            {
                name: 'name',
                simpleName: 'Ciklus studiranja',
                type: 'text',
            },
            {
                name: 'displayName',
                simpleName: 'Naziv ciklusa studiranja',
                type: 'text',
            },
            {
                name: 'number',
                simpleName: 'Broj',
                type: 'number',
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ],
    },
    {
        tableName: 'grouptypes',
        tableSimpleName: 'Tipovi grupa',
        url: '/group-types',
        frontEndPath: 'tipovi-grupa',
        columns: [
            {
                name: 'name',
                simpleName: 'Tipovi grupa',
                type: 'text'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ]
    },
    {
        tableName: 'markclasses',
        tableSimpleName: 'Vrsta ocjenjivanja',
        url: '/mark-classes',
        frontEndPath: 'vrsta-ocjenjivanja',
        columns: [
            {
                name: 'name',
                simpleName: 'Vrsta ocjenjivanja',
                type: 'text'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ]
    },
    {
        tableName: 'mark_status',
        tableSimpleName: 'Status ocjene',
        url: '/mark-statuses',
        frontEndPath: 'status-ocjene',
        columns: [
            {
                name: 'name',
                simpleName: 'Status ocjene',
                type: 'text'
            },
            {
                name: 'description',
                simpleName: 'Opis',
                type: 'textarea'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ]
    },
    {
        tableName: 'mark',
        tableSimpleName: 'Ocjena',
        url: '/marks',
        frontEndPath: 'ocjena',
        columns: [
            {
                name: 'name',
                simpleName: 'Naziv ocjene',
                type: 'text',
            },
            {
                name: 'number',
                simpleName: 'Ocjena',
                type: 'number',
            },
            {
                name: 'letter',
                simpleName: 'Oznaka ocjene',
                type: 'text',
            },
            {
                name: 'description',
                simpleName: 'Opis',
                type: 'textarea',
            },
            {
                name: 'displayName',
                simpleName: 'Naziv za prikaz',
                type: 'text'
            },
            {
                name: 'passed',
                simpleName: 'Položio',
                type: 'bool'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }

        ],
    },

    {
        tableName: 'position',
        tableSimpleName: 'Pozicija',
        url: '/positions',
        frontEndPath: 'pozicija',
        columns: [
            {
                name: 'name',
                simpleName: 'Naziv pozicije',
                type: 'text',
            },
            {
                name: 'jobDescription',
                simpleName: 'Opis posla',
                type: 'textarea',
            },
            {
                name: 'comment',
                simpleName: 'Napomena',
                type: 'textarea',
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ],
    },
    {
        tableName: 'organizationalUnitType',
        tableSimpleName: 'Tip organizacione jedinice',
        url: '/organizational-unit-types',
        frontEndPath: 'tip-organizacione-jedinice',
        columns: [
            {
                name: 'name',
                simpleName: 'Tip organizacione jedinice',
                type: 'text',
            },
            {
                name: 'description',
                simpleName: 'Opis',
                type: 'textarea',
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ],
    },
    {
        tableName: 'title',
        tableSimpleName: 'Titula',
        url: '/titles',
        frontEndPath: 'titula',
        columns: [
            {
                name: 'name',
                simpleName: 'Naziv titule',
                type: 'text',
            },
            {
                name: 'abbreviation',
                simpleName: 'Skraćenica',
                type: 'text',
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ],
    },
    {
        tableName: 'study_program_semester',
        tableSimpleName: 'Semestar studija',
        url: '/study-program-semesters',
        frontEndPath: 'semestar-studija',
        columns: [
            {
                name: 'name',
                simpleName: 'Naziv semestra studija',
                type: 'text',
            },
            {
                name: 'studyYear.name',
                simpleName: 'Godina studija',
                type: 'number',
            },
            {
                name: 'number',
                simpleName: 'Broj',
                type: 'number'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ],
    },
    {
        tableName: 'academic_title',
        tableSimpleName: 'Akademska titula',
        url: '/academic-titles',
        frontEndPath: 'akademska-titula',
        columns: [
            {
                name: 'name',
                simpleName: 'Naziv akademske titule',
                type: 'text',
            },
            {
                name: 'abbreviationPrefix',
                simpleName: 'Prefiks',
                type: 'text',
            },
            {
                name: 'abbreviationSuffix',
                simpleName: 'Sufiks',
                type: 'text',
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ],
    },
    {
        tableName: 'occupation_status',
        tableSimpleName: 'Zanimanje',
        url: '/occupation-statuses',
        frontEndPath: 'zanimanje',
        columns: [
            {
                name: 'name',
                simpleName: 'Naziv zanimanja',
                type: 'text',
            },
            {
                name: 'comment',
                simpleName: 'Napomena',
                type: 'textarea',
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ],
    },
    // {
    //     tableName: 'global_constants',
    //     tableSimpleName: 'Globalne konstante',
    //     url: '/global-constants',
    //     frontEndPath: 'globalne-konstante',
    //     columns: [
    //         {
    //             name: 'name',
    //             simpleName: 'Globalna konstanta',
    //             type: 'text',
    //         },
    //         {
    //             name: 'comment',
    //             simpleName: 'Napomena',
    //             type: 'textarea',
    //         },
    //     ],
    // },
    {
        tableName: 'grading_method',
        tableSimpleName: 'Način ocjenjivanja',
        url: '/grading-methods',
        frontEndPath: 'nacin-ocjenjivanja',
        columns: [
            {
                name: 'name',
                simpleName: 'Način ocjenjivanja',
                type: 'text',
            },
            {
                name: 'description',
                simpleName: 'Opis',
                type: 'textarea',
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ],
    },
    {
        tableName: 'graded_activity_type',
        tableSimpleName: 'Aktivnost koja se ocjenjuje',
        url: '/graded-activity-types',
        frontEndPath: 'aktivnost-koja-se-ocjenjuje',
        columns: [
            {
                name: 'name',
                simpleName: 'Aktivnost koja se ocjenjuje',
                type: 'text',
            },
            {
                name: 'inSemester',
                simpleName: 'U semestru',
                type: 'number',
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ],
    },
    {
        tableName: 'studyTypes',
        tableSimpleName: 'Tip studiranja',
        url: '/study-types',
        frontEndPath: 'tip-studiranja',
        columns: [
            {
                name: 'name',
                simpleName: 'Tip studiranja',
                type: 'text',
            },
            {
                name: 'displayName',
                simpleName: 'Naziv na sistemu',
                type: 'text',
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ],
    },
    {
        tableName: 'academicYears',
        tableSimpleName: 'Akademska godina',
        url: '/academic-years',
        frontEndPath: 'akademske-godine',
        columns: [
            {
                name: 'name',
                simpleName: 'Akademska godina',
                type: 'text'
            },
            {
                name: 'startYear',
                simpleName: 'Godina početka',
                type: 'number'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ]
    },
    {
        tableName: 'entity',
        tableSimpleName: 'Entitet',
        url: '/entities',
        frontEndPath: 'entiteti',
        columns: [
            {
                name: 'name',
                simpleName: 'Entitet',
                type: 'text'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ]
    },
    {
        tableName: 'genders',
        tableSimpleName: 'Spol',
        url: '/genders',
        frontEndPath: 'spolovi',
        columns: [
            {
                name: 'name',
                simpleName: 'Spol',
                type: 'text'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
            // {
            //     name: 'displayName',
            //     simpleName: 'Naziv na sistemu',
            //     type: 'text'
            // }
        ]
    },
    {
        tableName: 'professorThesesRole',
        tableSimpleName: 'Uloga profesora u izradi teze',
        url: '/professor-thesis-roles',
        frontEndPath: 'uloga-profesora-u-izradi-teze',
        columns: [
            {
                name: 'name',
                simpleName: 'Ime',
                type: 'text'
            },
            {
                name: '',
                simpleName: '',
                type: ''
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ]
    },
    {
        tableName: 'certificateReasons',
        tableSimpleName: 'Razlog za zahtjev statusne potvrde',
        url: '/certificate-reasons',
        frontEndPath: 'razlog-za-zahtjev-statusne-potvrde',
        columns: [
            {
                name: 'name',
                simpleName: 'Ime',
                type: 'text'
            },
            {
                name: 'description',
                simpleName: 'Opis',
                type: 'textarea'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ]
    },
    {
        tableName: 'asset_roomType',
        tableSimpleName: 'Vrsta sobe',
        url: '/room-types',
        frontEndPath: 'vrsta-sobe',
        columns: [
            {
                name: 'name',
                simpleName: 'Ime',
                type: 'text'
            },
            {
                name: 'description',
                simpleName: 'Opis',
                type: 'textarea'
            },
            {
                name: '',
                simpleName: '',
                type: 'buttons'
            }
        ]
    },
];

export const zero = 0;



// WEBPACK FOOTER //
// ./src/views/Lookups/lookupConfig.js